interface SiteTableHeaderProps {
  itemsPerPage: number;
  totalItems: number;
  totalPages: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;
}

export default function SiteTableHeader({
  itemsPerPage,
  totalItems,
  totalPages,
  onItemsPerPageChange,
}: SiteTableHeaderProps) {
  return (
    <div className="flex items-center space-x-4 mt-4 sm:mt-0">
      <div className="flex items-center space-x-2">
        <span className="text-sm text-gray-600">페이지당 항목:</span>
        <select
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
          className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white pr-8"
        >
          <option value={5}>5개 항목</option>
          <option value={10}>10개 항목</option>
          <option value={15}>15개 항목</option>
          <option value={20}>20개 항목</option>
          <option value={25}>25개 항목</option>
          <option value={50}>50개 항목</option>
          <option value={totalItems}>전체 항목 ({totalItems}개)</option>
        </select>
      </div>
      <div className=" hidden sm:block text-sm text-gray-500">
        {totalPages > 1 ? `총 ${totalPages}페이지` : '1페이지'}
      </div>
    </div>
  );
}
